import { enterpriseApiSlice } from "./index";
import { AnalyticsData } from "../Model/analyticsObjects";
import { PerformanceReportData } from "../Model/performanceReportObjects";
import { ANALYTICS_TYPE_PATHS } from "../AnalyticsHelperLib/AnalyticsDataHelper/analyticsDataHelperFunctions";

const CHART_TYPES = ["pickup", "delivery", "drive", "lateness"];

export const operationalAnalyticsApi = enterpriseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchCompanyAnalytics: builder.query({
      query: ({ analyticsType, timeframe }) => ({
        url: `/analytics/${ANALYTICS_TYPE_PATHS[analyticsType]}/${timeframe}`,
        method: "GET",
      }),
      extraOptions: { auth: true },
      providesTags: (_result, _error, { analyticsType, timeframe }) => [
        { type: "CompanyAnalytics", id: `${analyticsType}-${timeframe}` },
      ],
      transformResponse: (response, _meta, { analyticsType, timeframe }) =>
        new AnalyticsData(response, timeframe, analyticsType),
    }),
    fetchPerformanceReport: builder.query({
      async queryFn({ timeframe, orderType = "ondemand" }, _api, _extraOptions, baseQuery) {
        const summaryResult = await baseQuery({
          url: `/analytics/operational/summary/${timeframe}`,
          params: { orderType },
        });

        if (summaryResult.error) {
          return { error: summaryResult.error };
        }

        const chartResults = await Promise.all(
          CHART_TYPES.map((type) =>
            baseQuery({
              url: `/analytics/operational/${type}/${timeframe}`,
              params: { orderType },
            })
          )
        );

        for (const result of chartResults) {
          if (result.error) {
            return { error: result.error };
          }
        }

        return {
          data: new PerformanceReportData(
            summaryResult.data,
            {
              pickup: chartResults[0].data,
              delivery: chartResults[1].data,
              drive: chartResults[2].data,
              lateness: chartResults[3].data,
            },
            timeframe
          ),
        };
      },
      extraOptions: { auth: true },
      providesTags: (_result, _error, { timeframe, orderType }) => [
        { type: "PerformanceReport", id: `${timeframe}-${orderType}` },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useFetchCompanyAnalyticsQuery,
  useFetchPerformanceReportQuery,
} = operationalAnalyticsApi;
